// src/components/FeaturesSection.jsx
import { Sword, Pickaxe, Newspaper, Shirt, LayoutGrid } from "lucide-react";

const DISCORD_ICON = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="#818cf8">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

const features = [
  { icon: <Sword className="toa-ico-lg" />,  title: "Brotherhood",    desc: "More than a community - a creed. Every member is part of something greater, bound by loyalty and the will to rise." },
  { icon: DISCORD_ICON,                        title: "Discord Server", desc: "Thousands of members, curated channels, voice events, and real connections. Our Discord is the heart of TOA." },
  { icon: <Pickaxe className="toa-ico-lg" />, title: "Minecraft SMP",  desc: "Factions, a player-driven economy, custom actions, survival, roleplay, proximity voice chat, and custom items - Java and Bedrock cross-platform support." },
  { icon: <Newspaper className="toa-ico-lg" />, title: "Forum & Threads", desc: "Post guides, discuss strategy, submit maps, and share ideas with the rest of the brotherhood." },
  { icon: <Shirt className="toa-ico-lg" />,   title: "TOA Merch",     desc: "Official TOA clothing coming soon. Wear the creed, represent the brotherhood in real life." },
  { icon: <LayoutGrid className="toa-ico-lg" />, title: "TOA Hub App", desc: "Track daily habits, connect with members, add friends and grow together. The TOA Hub App is your all-in-one personal growth companion." },
];

export default function FeaturesSection() {
  return (
    <div className="toa-features" id="features">
      <div className="toa-fi">
        <div className="toa-slbl">What We Offer</div>
        <div className="toa-stit">One Community. Many Paths.</div>
        <div className="toa-sdiv" />
        <p className="toa-ssub">
          Built on brotherhood, creed, and the pursuit of growth. Whatever your passion, you will find your place here.
        </p>
        <div className="toa-fg">
          {features.map(({ icon, title, desc }) => (
            <div key={title} className="toa-fc">
              <div className="toa-fc-i">{icon}</div>
              <div className="toa-fc-t">{title}</div>
              <p className="toa-fc-d">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}